import { useEffect } from 'react';
import Navbar from '../layout/Navbar';
import Footer from '../layout/Footer';
import './ContentPage.css';

export default function ContentPage({ eyebrow, title, lead, children }) {
  useEffect(() => {
    document.title = `${title} — NAYAVARNAM`;
  }, [title]);

  return (
    <div className="page-shell">
      <Navbar />
      <main className="content-page">
        <div className="container">
          <header className="content-page__hero">
            {eyebrow && <p className="content-page__eyebrow">{eyebrow}</p>}
            <h1 className="content-page__title">{title}</h1>
            {lead && <p className="content-page__lead">{lead}</p>}
          </header>
          <div className="content-page__body">{children}</div>
        </div>
      </main>
      <Footer />
    </div>
  );
}
